import RaizHambre from "./RaizHambre";

export default RaizHambre;